import { defineStore } from 'pinia';

export enum BankIDState {
  OUTSTANDING_TRANSACTION,
  NO_CLIENT,
  STARTED,
  USER_SIGN,
  USER_REQ,
  COMPLETE,
  USER_CANCEL,
}

export const useMyBankIdStore = defineStore('myBankIdStore', {
  state: () => ({
    currentBankIdState: BankIDState.NO_CLIENT as BankIDState,
  }),
  actions: {},
});
